import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment-timezone'
import i18n_messages from './i18n/i18n.json'
import i18n_currencies from './i18n/i18n-currencies.json'

Vue.use(VueI18n)
moment.locale('fr');
Vue.use(moment);

const i18n = new VueI18n({ locale: 'fr', messages:i18n_messages, numberFormats : i18n_currencies })

export default i18n;
